import React, { Component } from 'react';
import PT from 'prop-types';
import NoSSR from 'react-no-ssr';
import classes from './ToolDescriptions.css';

export class ToolDescription extends Component {
  static propTypes = {
    descr: PT.string,
  };

  static defaultProps = {
    descr: '',
  };

  state = {
    toolsLoadError: false,
    showMore: false,
  };

  componentWillReceiveProps = () => {
    this.setState({ toolsLoadError: false });
  };

  handleToolError = () => this.setState({ toolsLoadError: true });

  dangerizeMyText = (descr) => {
    var text = descr.toString();
    var words = text.trim().split(/\s+/).length;
    words > 16 ? this.showMoreLessButtons = true : this.showMoreLessButtons = false;
    if (this.state.showMore) {
      text = text;
    } else {
      text = text.replace(/(([^\s]+\s\s*){16})(.*)/,"$1…");
    }
    return React.DOM.span({ dangerouslySetInnerHTML: { __html: text } });
  }

  handleToggleShowMore = () => {
    this.setState({ showMore: !!!this.state.showMore });
  }

  render() {
    const { descr } = this.props;
    const { toolsLoadError } = this.state;
    const showMoreLessButtons = true;
    return (
      <span className={classes.toolDescriptionContainer}>
        <span>
          {this.dangerizeMyText(descr)}
        </span>
        {this.showMoreLessButtons && (
            <span className={classes.moreLessButton} onClick={this.handleToggleShowMore.bind()}>{this.state.showMore ? 'less' : 'more'}</span>
        )}
      </span>

    );
  }
}

export default ToolDescription;



// WEBPACK FOOTER //
// ./src/app/components/ToolDescriptions/ToolDescriptions.js